import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onUnmounted, ref } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollToTop',
  setup(__props) {

const visible = ref(false)

const onScroll = () => {
  visible.value = window.scrollY > 400
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "scroll-top",
    "aria-label": "맨 위로",
    onClick: scrollToTop
  }, [
    _createVNode(AppIcon, {
      icon: "mdi-chevron-up",
      size: 24
    })
  ], 512)), [
    [_vShow, visible.value]
  ])
}
}

})